import React, { useState } from 'react'
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Login = ({setShowLogin}) => {

  const [error, setError] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  
  const handleLogin = async(e) => {
    e.preventDefault();
    setError('');

    try{
      const response = await axios.post('http://localhost:3002/api/login', {phone, password}, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      console.log(response.data);
      localStorage.setItem('user', JSON.stringify(response.data));
      alert('Login Successful');

      if(response.data.name === `swalokgroup` && response.data.phone === `1234512345`){
        navigate('/admin/dashboard', {state: response.data});
        window.location.reload();
      }

      else{
        navigate('/user/dashboard', {state: response.data});
        window.location.reload();
      }
    }
    catch(error){
      console.log('Cannot Login to account', error.response?.data || error.message);
      setError('Login Failed. User not exist');
    }
  };


  return (
    <>
      <section className='my-5'>
        <div className='container text-center'>

          <p className='sec-subheading'><hr /><span>Login</span><hr /></p>
          <p className='sec-heading'>Get into your Account</p>

          <div className='bg-body-tertiary px-4 py-5 mt-4 col-lg-5 col-md-10 col-12 mx-auto text-start'>
            <form class="row g-3" onSubmit={handleLogin}>
              <div class="col-12">
                <input type="tel" class="form-input" name='phone' value={phone} onChange={(e) => setPhone(e.target.value)} placeholder='Your Phone' required />
              </div>
              <div class="col-12">
                <input type="password" class="form-input" name='password' value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Enter Password" required />
              </div>
              {error && <div className="text-danger">{error}</div>}
              <div class="col-12 my-4">
                <button type="submit" class="banner-btn w-100">Login</button>
              </div>
            </form>  
            <p className='text-center fst-italic'>Didn't have an Account? <span className='toggle-link' onClick={() => setShowLogin(false)}>Signin</span> Here.</p>

            {/* form ends */}
          </div>

        </div>
      </section>
    </>
  )
}

export default Login
